import { useGoodsOptionsBrief } from '../queries/useGoodsOptionsBrief';
import { useCallback } from 'react';
import { useConfigs } from 'shared/src/queries';
import { getCurrentTimeDiff, getHour, isNil } from 'shared/src/utils';

export const useGetOrderDeadlineText = () => {
  const { data: optionsBrief } = useGoodsOptionsBrief();
  const { data: configs } = useConfigs();

  const getLimitTime = useCallback(
    (params: { delivery_type: 'shak' | 'today' }) => {
      if (isNil(optionsBrief)) return null;
      // configs?.shak_delivery.operation_end_time
      if (params.delivery_type === 'shak')
        return getHour(configs?.shak_delivery.operation_end_time);
      return getHour(optionsBrief.today_delivery_order_deadline_time);
    },
    [configs?.shak_delivery.operation_end_time, optionsBrief],
  );

  return useCallback<
    (params: { delivery_type: 'shak' | 'today' | 'standard' }) => string
  >(
    params => {
      if (isNil(optionsBrief)) {
        return '';
      }
      if (params.delivery_type === 'standard') {
        return '';
      }

      const limitTime = getLimitTime({ delivery_type: params.delivery_type });
      if (isNil(limitTime)) return '';

      const diffSecond = getCurrentTimeDiff(limitTime);
      const isTimeOver = diffSecond > 0;

      if (isTimeOver) {
        return '주문 마감으로 내일 출발!';
      }

      const hour = limitTime.hour();
      return `${hour < 12 ? '오전 ' : '오후 '}${hour > 12 ? hour - 12 : hour}시 전 주문하면 오늘 출발!`;
    },
    [getLimitTime, optionsBrief],
  );
};
